export function capitalizeFirstLetter(input: string) {
  if (!input) {
    return input;
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function removeNonAlphabetic(input: string) {
  if (!input) {
    return input;
  }
  return input.replace(/[^a-zA-Z]/g, "");
}

export function removeNonNumeric(input: string) {
  if (!input) {
    return input;
  }
  return input.replace(/\D/g, "");
}
